// DashboardHeader.jsx
import React, { useState } from "react";
import { NavLink, useNavigate, useSearchParams } from "react-router-dom";
import CreateNewPopover from "./CreateNewPopover";
import { logout as clearSession } from "../lib/session";
import logo from '../assets/clikkle-creator.png';

export default function DashboardHeader() {
  const navigate = useNavigate();
  const [showCreate, setShowCreate] = useState(false);
  const [showWorkspace, setShowWorkspace] = useState(false);
  const [_, setSearch] = useSearchParams();
  
  // For storing selected brand
  const [selectedBrand, setSelectedBrand] = useState(null);

  // Handle brand selection
  const handleBrandSelect = (brand) => {
    setSelectedBrand(brand);  // Set the selected brand
  };

  function logout() {
    clearSession();
    localStorage.removeItem("token");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("sessionToken");
    localStorage.removeItem("user");
    navigate("/login", { replace: true });
  }

  function goToTab(tab) {
    navigate(`/dashboard?tab=${tab}`);
    setShowWorkspace(false);
  }

  return (
    <header className="bg-white border-b border-slate-100">
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        <NavLink to="/dashboard">
          <img src={logo} alt="Clikkle Logo" className="h-12" />
        </NavLink>

        <div className="flex items-center gap-4 relative">
          {/*<button className="px-4 py-2 rounded-full bg-blue-500 text-white font-semibold">
            2026 Special Offer!
          </button>*/}

          <div className="relative">
            <button
              onClick={() => setShowCreate(v => !v)}
              className="px-4 h-10 rounded-full border border-sky-300 text-sky-700 bg-white flex items-center gap-2"
            >
              Create New
              <span>▾</span>
            </button>
            {showCreate && (
              <CreateNewPopover 
                onClose={() => setShowCreate(false)} 
                selectedBrand={selectedBrand}  // Pass selectedBrand to the modal
                onBrandSelect={handleBrandSelect} // Handle brand select
              />
            )}
          </div>

          <div className="relative">
            <button
              onClick={() => setShowWorkspace(v => !v)}
              className="text-slate-700"
            >
              My Workspace ▾
            </button>
            {showWorkspace && (
  <div className="absolute right-0 mt-2 w-56 bg-white rounded-xl shadow border border-slate-100 z-40">
    <button
      type="button"
      onClick={() => {
        setShowWorkspace(false);
        setTimeout(() => navigate("/mycalendar"), 0);
      }}
      className="w-full text-left px-4 py-2 hover:bg-slate-50"
    >
      Clikkle AI Generator
    </button>

    <button
      type="button"
      onClick={() => goToTab("drafts")}
      className="w-full text-left px-4 py-2 hover:bg-slate-50"
    >
      Draft Content
    </button>

    <button
      type="button"
      onClick={() => goToTab("published")}
      className="w-full text-left px-4 py-2 hover:bg-slate-50"
    >
      Published Content
    </button>

    <button
      type="button"
      onClick={() => goToTab("brands")}
      className="w-full text-left px-4 py-2 hover:bg-slate-50"
    >
      Brands
    </button>
  </div>
)}

          </div>

          <button onClick={logout} className="h-9 w-9 rounded-full bg-slate-100 grid place-items-center font-bold">
            U
          </button>
        </div>
      </div>
    </header>
  );
}
